interface Props {
  score: number;
}

const ConfidenceScore: React.FC<Props> = ({score}) => {
  const strokeWidthBg = 1; // Background circle stroke width (thinner)
  const strokeWidthFg = 3; // Foreground (filled) circle stroke width (thicker)
  const radius = 9; // Smaller radius to fit within 24x24
  const circumference = 2 * Math.PI * radius; // Circle circumference
  const progress = score * circumference; // Stroke dash offset

  const getColor = (score: number) => {
    if (score >= 0.8) return '#04A269'; // Green
    if (score >= 0.51) return '#FF9E2C'; // Orange
    return '#E2294A'; // Red
  };

  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      {/* Background Circle (Empty Part) */}
      <circle
        cx="12"
        cy="12"
        r={radius}
        fill="none"
        stroke="#93A2B9"
        strokeWidth={strokeWidthBg}
      />
      {/* Foreground Circle (Filled Part) */}
      <circle
        cx="12"
        cy="12"
        r={radius}
        fill="none"
        stroke={getColor(Number(score))}
        strokeWidth={strokeWidthFg}
        strokeDasharray={circumference}
        strokeDashoffset={circumference - progress}
        strokeLinecap="round"
        transform="rotate(-90 12 12)"
      />
    </svg>
  );
};

export default ConfidenceScore;
